import { PHOTO_CAPTURE_GET_FOLDERS_REQUEST, PHOTO_CAPTURE_GET_FOLDERS_SUCCESS } from '../actions';
export const photoCaptureFoldersReducer = (state, action) => {
    switch (action.type) {
        case PHOTO_CAPTURE_GET_FOLDERS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, isFolderServiceCompleted: false });
        case PHOTO_CAPTURE_GET_FOLDERS_SUCCESS: {
            const { photoCaptureGetFolders } = action.payload;
            const updatedFolderList = Array.isArray(photoCaptureGetFolders)
                ? photoCaptureGetFolders.filter(({ isActive }) => isActive)
                : [];
            return Object.assign(Object.assign({}, state), { isLoading: false, folderOptionList: updatedFolderList, isFolderServiceCompleted: true });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureFoldersReducer.js.map